<script setup lang="ts">
import { IconLoader2 } from '@tabler/icons-vue';
</script>

<template>
    <div class="flex items-center justify-center h-full w-full">
        <div class="flex flex-col items-center justify-center space-y-2">
            <IconLoader2 class="size-8 animate-spin text-zinc-800 dark:text-zinc-300" />
            <div class="text-sm text-zinc-800 dark:text-zinc-300">Loading...</div>
        </div>
    </div>
</template>